<template>
    <v-dialog v-model="editorShownDayoff" width="850" persistent>
        <!-- Begin:Content:Mode:update ------------------------------------- -->
        <v-card v-if="editorMode === 'update'" style="border: 2px solid yellow;">
            <!-- Card Title ------------------------------------------------ -->
            <v-card-title class="blue-grey lighten-1 pa-5" style="color: white; font-size: 15px; font-weight: 500;">
                <i style="font-size:20px; color: yellow;" class="b-fa b-fa-coffee"></i>&nbsp;&nbsp;{{ this.eventName || '&nbsp;' }} - Multiple ({{ editorMode.toUpperCase() }})
            </v-card-title>

            <!-- Selected Dayoff List -------------------------------------- -->
            <div style="font-size: 15px; font-weight: 700; color: #606263; padding-left: 28px; margin-top:15px; margin-bottom: 0px;"><i style="font-size:15px; color: yellow; padding-right: 10px;" class="b-fa b-fa-coffee"></i><strong>Choose your Employees/Dayoffs:</strong></div>
            <selected-dayoff-list v-model="employees" v-if="editorShownDayoff" />

            <v-divider style="margin-top: 0px;"></v-divider>

           <!-- Selecting Dayoff ------------------------------------------- -->
            <div style="font-size: 15px; font-weight: 700; color: #606263; padding-left: 28px; margin-top:15px;"><i style="font-size:15px; color: yellow; padding-right: 10px;" class="b-fa b-fa-coffee"></i><strong>Update your Dayoff:</strong></div>
            <v-card-text class="pa-5">
                <datetime v-model="startDate" label="OffDay - from" disabled="false" disabledTime="true" ref="startTimer" />
                <datetime v-model="endDate" label="OffDay - to" disabled="true" disabledTime="true" ref="endTimer" />

                <v-row>
                    <v-col cols="6" class="">
                        <checkbox v-model="requested" label="Requested?" />
                    </v-col>

                    <v-col cols="6" class="">
                        <checkbox v-model="remainingDayOff" label="From last year?" />
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-text class="pa-5">
                <comment-textarea v-model="dutyComment" label="Dayoff Comment:" maxlength="300" />
            </v-card-text>

            <v-divider></v-divider>

            <!-- Card Actions ---------------------------------------------- -->
            <v-card-actions>
                <span style="font-size: 12px; font-weight: 700; color: #606263; padding-left: 25px;"><strong>Status: {{ get_selectedMultiEvents('DAYOFF').length }} Dayoff(s) in Scheduler selected</strong></span>
                <div class="flex-grow-1"></div>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="onClose_DayoffDialog">Cancel</v-btn>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="onSave_DayoffUpdate"> Save</v-btn>
            </v-card-actions>
        </v-card>



        <!-- Begin:Content:Mode:create ------------------------------------- -->
        <v-card v-if="editorMode === 'create'" style="border: 2px solid yellow;">
            <!-- Card Title ------------------------------------------------ -->
            <v-card-title class="blue-grey lighten-1 pa-5" style="color: white; font-size: 15px;  font-weight: 500;">
                <i style="font-size:20px; color: yellow;" class="b-fa b-fa-coffee"></i>&nbsp;&nbsp;{{ this.eventName || '&nbsp;' }} - Multiple ({{ editorMode.toUpperCase() }})
            </v-card-title>

            <!-- Selected Employees List ----------------------------------- -->
            <div style="font-size: 15px; font-weight: 700; color: #606263; padding-left: 28px; margin-top:15px; margin-bottom: 0px;"><i style="font-size:15px; color: yellow; padding-right: 10px;" class="b-fa b-fa-user"></i><strong>Choose your Employees:</strong></div>
            <selected-employees-list v-model="employees" v-if="editorShownDayoff" />

            <v-divider style="margin-top: 0px;"></v-divider>

            <!-- Selecting Dayoff ------------------------------------------ -->
            <div style="font-size: 15px; font-weight: 700; color: #606263; padding-left: 28px; margin-top:15px;"><i style="font-size:15px; color: yellow; padding-right: 10px;" class="b-fa b-fa-coffee"></i><strong>Build your Dayoff(s):</strong></div>
            <v-card-text class="pa-5">
                <datetime v-model="startDate" label="OffDay - from" disabled="false" disabledTime="true" ref="startTimer" />
                <datetime v-model="endDate" label="OffDay - to" disabled="false" disabledTime="true" ref="endTimer" />

                <v-row>
                    <v-col cols="6" class="">
                        <checkbox v-model="requested" label="Requested?" />
                    </v-col>

                    <v-col cols="6" class="">
                        <checkbox v-model="remainingDayOff" label="From last year?" />
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-text class="pa-5">
                <comment-textarea v-model="dutyComment" label="Dayoff Comment:" maxlength="300" />
            </v-card-text>

            <v-divider></v-divider>

            <!-- Card Actions ---------------------------------------------- -->
            <v-card-actions>
                <span style="font-size: 12px; font-weight: 700; color: #606263; padding-left: 25px;"><strong>Status: {{ get_selectedMultiResources.length }} Employee(s) in Scheduler selected</strong></span>
                <div class="flex-grow-1"></div>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="onClose_DayoffDialog">Cancel</v-btn>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="onSave_DayoffCreate"> Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import Vue from 'vue';
    import Datetime from '../../DateTime.vue';
    import Checkbox from '../../Checkbox.vue';
    import CommentTextarea from '../../CommentTextarea.vue';
    import SelectedDayoffList from '../../SelectedDayoffList.vue';
    import SelectedEmployeesList from '../../SelectedEmployeesList.vue';

    import { mapActions, mapGetters } from 'vuex';
    import { eventBus } from '../../../../../../../main';
    import moment from 'moment';


    export default {
        name  : 'event-editor-dayoff',

        /* >>> *************************************************************** / /* Props */
        props : {

            value           : [ Boolean, Object ],                              // editorShownDayoff
            eventStore      : Object,                                           // 'update'
            resourceId      : [ String, Number ],                               // 'update'
            eventRecord     : Object,                                           // 'update'
            resourceRecord  : Object,                                           // 'create'
            addDate         : Date,                                             // 'create'
            eventName       : String,                                           // 'update', 'create'
            editorMode      : String,                                           // 'update', 'create'

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components : {

            Datetime,
            Checkbox,
            CommentTextarea,
            SelectedDayoffList,
            SelectedEmployeesList

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: () => ({

            // >>> ------------------------------
            startDate       : null,
            endDate         : null,
            // >>> ------------------------------
            requested       : null,
            remainingDayOff : null,
            // >>> ------------------------------
            dutyComment     : null,
            employees       : [],
            // >>> ------------------------------

        }), // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed : {

            ...mapGetters([
                'get_selectedMultiResources',
                'get_selectedMultiEvents',
                'get_shared_IsEditingInThePastAllowed'
            ]),


            /*******************************************************************
            * editorShownDayoff()
            *
            * Desc:
            * Note: Distinguishes between editorMode: 'update', 'create'
            *
            */
            editorShownDayoff: {

                /***************************************************************
                * get()
                *
                * Desc:
                * Note: Distinguishes between editorMode: 'update', 'create'
                * Note: Set '23:59' to Create endDate.
                *
                */
                get() {

                    let me = this,
                        timestamp = null,
                        startDate = null,
                        endDate = null,
                        resourceRecord = me.resourceRecord,
                        eventRecord = me.eventRecord;


                    me.$toc('>>> views/crewplanning/crewcalendar/components/editevents/dayoff/EventEditor.vue >>> editorShownDayoff get');
                    if (true === me.value) {                                    // we're opening so initialize data

                        // >>> ------------------ update
                        if (this.editorMode === 'update') {
                            if (eventRecord) {
                                Object.assign(me, {
                                    eventName       : this.eventName, // eventRecord.name,
                                    startDate       : new Date(eventRecord.startDate),
                                    endDate         : new Date(eventRecord.endDate),
                                    requested       : eventRecord.requested,
                                    remainingDayOff : eventRecord.remainingDayOff,
                                    dutyComment     : eventRecord.dutyComment,
                                });
                            }
                        }

                        // >>> ------------------ create
                        if (this.editorMode === 'create') {
                            if (resourceRecord) {
                                timestamp = new Date(this.addDate).setHours(0, 0, 0, 0);
                                startDate = new Date(timestamp);
                                timestamp = new Date(this.addDate).setHours(23, 59, 0, 0);
                                endDate = new Date(timestamp);

                                Object.assign(me, {
                                    eventName       : this.eventName,
                                    startDate       : startDate,
                                    endDate         : endDate,
                                    requested       : false,
                                    remainingDayOff : false,
                                    dutyComment     : null
                                });
                            }
                        }

                    } else if (false === me.value) {                            // we're closing so fire close event
                        // this.$emit('close'); // Needed?
                    }


                    return !!this.value; // return always Boolean

                }, // eo function editorShownDayoff get()


                /***************************************************************
                * set()
                *
                * Desc:
                * Note: only runs on close.
                */
                set(value) {

                    let me = this;;


                    me.$toc('>>> views/crewplanning/crewcalendar/components/editevents/dayoff/EventEditor.vue >>> editorShownDayoff set');
                    this.$emit('input', value);

                } // eo function editorShownDayoff set()

            } // eo editorShownDayoff{}

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc: Listen to 'updatedayoff'.
        * Note: Runs after the instance is created. Installs Listeners.
        *
        */
		created: function () {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/dayoff/EventEditor.vue >>> created');
            eventBus.$on('updatedayoff', this.onUpdate_SingleDuty); // call: update single duty successful
            eventBus.$on('onchangedatepicker', this.onChange_DatePicker); // onChange_DatePicker

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/dayoff/EventEditor.vue >>> beforeDestroy');
            eventBus.$off('updatedayoff', this.onUpdate_SingleDuty);
            eventBus.$off('onchangedatepicker', this.onChange_DatePicker);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_set_SelectedMultiEvents',
                'actn_create_Multiple_Duty',
                'actn_update_Multiple_Duty',

                'actn_update_SingleDuty', // Call: Modify Single Duty
                'actn_create_SingleDuty', // Call: Create Single Duty
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners: Save Handlers
            *******************************************************************/
            /*******************************************************************
            * onSave_DayoffUpdate()
            *
            * Desc:
            * Note: Check if edit in past is allowed.
            *
            */
            onSave_DayoffUpdate: function(){

                let me = this,
                    singleParamObject = {},
                    params = {
                        breaks : []
                    };


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/dayoff/EventEditor.vue >>> onSave_DayoffUpdate');
                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [me.startDate], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                this.employees.forEach(employee => {
                    singleParamObject = {
                        id: employee.originalId,
                        idResource: employee.resourceId,
                        from: moment(me.startDate).format('YYYY-MM-DDT05:00:ss+0000'),
                        to: moment(me.endDate).format('YYYY-MM-DDT21:00:ss+0000'),
                        type: 'DAYOFF',
                        status: 'PLANNED',
                        requested: me.requested,
                        remainingDayoff : me.remainingDayOff,
                        activated: me.eventRecord.activated,
                        dutyComment: me.dutyComment !== '' ? me.dutyComment : null
                    };
                    params.breaks.push(singleParamObject);
                });

                if (this.validateParams(params) === true) {
                    this.actn_update_Multiple_Duty(params);
                    // this.actn_set_SelectedMultiEvents([]);                      // send empty Array
                    // this.onClose_DayoffDialog();
                }

            }, // eo function onSave_DayoffUpdate


            /*******************************************************************
            * onSave_DayoffCreate()
            *
            * Desc:
            * Note:
            * Note: Check if edit in past is allowed.
            *
            */
            onSave_DayoffCreate: function () {

                let me = this,
                    params = {};


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/dayoff/EventEditor.vue >>> onSave_DayoffCreate');
                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [me.startDate], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                params = {
                    id              : null,
                    // idResource      : this.resourceRecord.id,
                    idResources     : this.employees,
                    from            : moment(me.startDate).format('YYYY-MM-DDT05:00:ss+0000'),
                    to              : moment(me.endDate).format('YYYY-MM-DDT21:00:ss+0000'),
                    requested       : me.requested,
                    remainingDayoff : me.remainingDayOff,
                    type            : 'DAYOFF',
                    status          : 'PLANNED',
                    activated       : false,
                    split           : true,
                    dutyComment     : me.dutyComment !== '' ? me.dutyComment : null
                };

                if (this.validateParams(params) === true) {
                    this.actn_create_Multiple_Duty(params);
                    this.actn_set_SelectedMultiEvents([]); // send empty Array
                    // this.onClose_UnableFlightDialog();
                }

            }, // eo function onSave_DayoffCreate()


            /*******************************************************************
            * onClose_DayoffDialog()
            *
            * Desc: Close 'Dayoff' Dialog.
            * Note: Reset 'all selected Events' here.
            *
            */
            onClose_DayoffDialog: function() {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/dayoff/EventEditor.vue >>> onClose_DayoffDialog');
                this.actn_set_SelectedMultiEvents([]);                          // send empty Array, #244
                me.editorShownDayoff = false;

                eventBus.$emit('schedulerdeselectall');                         // #401

            }, // eo function onClose_DayoffDialog()




            /******************************************************************* 'Listeners - eventBus'
            * Listeners:
            *******************************************************************/
            /******************************************************************* 'Update'
            * onUpdate_SingleDuty()
            *
            * Desc: Successful Call => emits 'updatedayoff' Event.
            * Desc: Change Data in Scheduler.
            * Note: Using Response of Call:'actn_update_SingleDuty' for
            * Note: buildEventNote.
            * Note: 'Create' happens in CrewCalendar.
            *
            * @param {Object} response (Response from Call)
            */
            onUpdate_SingleDuty: function(response) {

                let me = this,
                    style = null,
                    tooltiptData = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/dayoff/EventEditor.vue >>> onUpdate_SingleDuty emited');
                me.eventRecord.setStartEndDate(me.startDate, me.endDate);
                me.eventRecord.set({ requested: me.requested });
                me.eventRecord.set({ remainingDayOff: me.remainingDayOff });
                me.eventRecord.set({ dutyComment: response.dutyComment });

                tooltiptData = me.$buildEventNote(response); // Catch after 'requested was set!: Important

                me.eventRecord.set({ nameEvent: tooltiptData.nameEvent });
                me.eventRecord.set({ note: tooltiptData.note });

                // >>> Style ----------------------------------------
                if (response.dutyComment !== null) {
                    if (me.eventRecord.style !== null) {
                        style = me.eventRecord.style  + ' border-right: 3px dotted #000;';
                    } else {
                        style = ' border-right: 3px dotted #000;';
                    }
                }
                me.eventRecord.set({ style: style });
                // <<< Style ----------------------------------------

                if(!me.eventRecord.eventStore) {
                    me.eventStore.add(me.eventRecord);
                    me.eventRecord.resourceId = me.resourceId;
                }

                // >>> close the editor now ...
                me.editorShownDayoff = false;

            }, // eo function onUpdate_SingleDuty()


            /*******************************************************************
            * onChange_DatePicker()
            *
            * Desc: If Start DatePicker changed, it emits an Event and its
            * Desc: new Value to set it to End DatePicker.
            * Note: Set the same Start/End Day only in Mode:'update'.
            *
            * @param {String} value ()
            */
            onChange_DatePicker: function(value){

                let me = this,
                    newDate = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/dayoff/EventEditor.vue >>> onChange_DatePicker emited');
                // >>> ------------------ update
                if (this.editorMode === 'update') {
                    newDate = new Date(value);
                    newDate.setHours(23);
                    newDate.setMinutes(59);
                    me.endDate = newDate;
                }

            }, // eo function onChange_DatePicker()




            /*******************************************************************
            * Validators:
            *******************************************************************/
            /*******************************************************************
            * validateParams()
            *
            * Desc:
            * Note:
            *
            * @param {Object} params (Params we want to send)
            */
            validateParams: function(params) {

                let me = this,
                    startDate = null,
                    endDate = null,
                    valid = false;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/dayoff/EventEditor.vue >>> validateParams');
                startDate = moment(params.from);
                endDate = moment(params.to);

                if (endDate.isBefore(startDate)) {
                    valid = false;
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: 'Validation: EndDate must be after StartDate.'
                    });
                } else {
                    valid = true;
                }


                return valid;

            }, // eo function validateParams()

        }, // eo methods{}
        /* <<< ****************************************************************/

    };
</script>
